import {Routes} from 'constants/routes';

import {faEnvelope, faLock} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Button from 'components/Button/Button';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import {Link} from 'react-router-dom';
import {LoginDTO} from 'typescript/dto/authDto';

import {deleteAccountSchema} from './deleteAccountValidation';

const initialValues: LoginDTO = {
  email: '',
  password: '',
};

export default function DeleteLoginForm({handleSubmit}: {handleSubmit: (values: LoginDTO) => Promise<void>}) {
  return (
    <div className="delete-account__container">
      <div className="delete-account__welcome">
        <h1 className="delete-account__welcome-title">Delete Account</h1>
        <h2 className="delete-account__welcome-subtitle">You must login before deleting your account.</h2>
      </div>
      <Formik onSubmit={handleSubmit} initialValues={initialValues} validationSchema={deleteAccountSchema}>
        <Form className="delete-account__form">
          <div className="delete-account__form-control">
            <label className="delete-account__form-label">
              <FontAwesomeIcon icon={faEnvelope} />
              <Field name="email" placeholder="email@example.com" className="delete-account__form-input" />
            </label>
            <ErrorMessage className="delete-account__form-error" component="span" name="email" />
          </div>
          <div className="delete-account__form-control">
            <label className="delete-account__form-label">
              <FontAwesomeIcon icon={faLock} />
              <Field name="password" type="password" placeholder="●●●●●●●●" className="delete-account__form-input" />
            </label>
            <ErrorMessage className="delete-account__form-error" component="span" name="password" />
          </div>
          <div className="delete-account__forgot-password">
            <Link to={Routes.FORGOT_PASSWORD} className="delete-account__forgot-password-link">
              Forgot Password?
            </Link>
          </div>
          <div className="delete-account__cloud-down">
            <div className="delete-account__actions">
              <Button className="delete-account__signin-btn" variant="tertiary" type="submit">
                Sign In
              </Button>
            </div>
          </div>
        </Form>
      </Formik>
      <div className="delete-account__footer" />
    </div>
  );
}
